export default __webpack_public_path__ + "static/media/man-mittel-freisteller.3c22f191.png";